<template>
    <rkm-modal
        :buttons="['cancel']"
        extra-large
        ref="Modal"
        title="Atendimentos"
    >
        <BoxHistorico
            v-if="atendimentosData"
            :data="atendimentosData"
            hide-historico-v1
        />
    </rkm-modal>
</template>

<script>
// Components.
import BoxHistorico from '@/components/ambulatorio/atendimento/components/historico/Index'

// Vuex.
import { mapActions } from 'vuex'

// Mixins.
import { repository, error } from '@/mixins'

export default {
    components: {
        BoxHistorico,
    },
    created() {
        this.repositories = {
            monitoramentoProtocolo: this.getConectaSusRepository('regulacao.monitoramentoProtocolo')
        }
    },
    data: () => ({
        acompanhamentoOci: null,
        atendimentosData: null,
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        open(item) {

            this.acompanhamentoOci = item

            this.load()

            this.$refs.Modal.show()
        },
        load() {

            this.atendimentosData = null

            this.setLoading()

            this.repositories.monitoramentoProtocolo.getAtendimentos(this.acompanhamentoOci.id)
                .then(({ data }) => this.atendimentosData = data)
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
    },
    mixins: [repository, error],
}
</script>